import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import Moment from "react-moment";
import moment from "moment";
import { VscCloseAll, VscExpandAll } from "react-icons/vsc";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

/* Stylesheet */
import "./styles.scss";

/* Components */
import ServicesOfferedSelection from "../../../../components/ServicesOfferedSelection";
import Header from "../../../../components/Header";

/* Widgets */
import Button from "../../../../widgets/Button";
import ButtonLink from "../../../../widgets/ButtonLink";
import Spinner from "../../../../widgets/Spinner";
import DatePicker from "../../../Visits/AppointmentRequest/datepicker";
import RadioButton from "../../../../widgets/RadioButton";
import BrowseFile from "../../../../widgets/BrowseFile";
import uploadIcon from "../../../../assets/images/upload-icon.svg";

/* Recoil */
import { selectedServiceListState } from "../../../../atoms/signUpAtom";
import { currentUserAccessToken, currentUserInfo } from "../../../../atoms/signInAtom";


/* Icons */
import { MdAddAPhoto } from "react-icons/md";

/* Utils */
import provincesList from "../../../../utils/provincesList";

const EditCaregiverProfile = (props) => {
  const role = props.role;
  const { t: tProfile, i18n } = useTranslation(["profile"]);
  // const { t:  } = useTranslation(["visits"]);
  const navigate = useNavigate();
  const userInfo = useRecoilValue(currentUserInfo);

  const [firstName, setFirstName] = useState(userInfo && userInfo?.user?.first_name);
  const [lastName, setLastName] = useState(userInfo && userInfo?.user?.last_name);
  const [middleName, setMiddleName] = useState(userInfo && userInfo?.user?.middle_name);
  const [gender, setGender] = useState(userInfo && userInfo.profile && userInfo.profile.gender);
  const [address, setAddress] = useState(userInfo && userInfo.profile && userInfo.profile.address);
  const [country, setCountry] = useState(userInfo && userInfo.profile && userInfo.profile.country);
  const [city, setCity] = useState(userInfo && userInfo.profile && userInfo.profile.city);
  const [province, setProvince] = useState(userInfo && userInfo.profile && userInfo.profile.state);
  const [postalCode, setPostalCode] = useState(userInfo && userInfo.profile && userInfo.profile.zip);
  const [additionalInfo, setAdditionalInfo] = useState(userInfo && userInfo.profile && userInfo.profile.bio);
  const [phoneNumber, setPhoneNumber] = useState(userInfo && userInfo.profile && userInfo.profile.phone);
  const [faxNumber, setFaxNumber] = useState(userInfo && userInfo.profile && userInfo.profile.fax);

  const [availableForWorkWithinOneMonth, setAvailableForWorkWithinOneMonth] = useState(
    userInfo && userInfo.profile && userInfo.profile.work_within_1_month === true ? "Yes" : "No"
  );
  const [culturalBackground, setCulturalBackground] = useState(
    userInfo && userInfo.profile && userInfo.profile.cultural_background_caregiver === true ? "Yes" : "No"
  );
  const [workWithDog, setWorkWithDog] = useState(userInfo && userInfo.profile && userInfo.profile.work_with_dog === true ? "Yes" : "No");
  const [workWithCat, setWorkWithCat] = useState(userInfo && userInfo.profile && userInfo.profile.work_with_cat === true ? "Yes" : "No");
  const [workWithSmoker, setWorkWithSmoker] = useState(
    userInfo && userInfo.profile && userInfo.profile.work_with_smoker === true ? "Yes" : "No"
  );
  const [climbStairs, setClimbStairs] = useState(
    userInfo && userInfo.profile && userInfo.profile.go_up_down_stairs === true ? "Yes" : "No"
  );
  const [ableToWork, setAbleToWork] = useState(userInfo && userInfo.profile && userInfo.profile.able_to_work === true ? "Yes" : "No");
  const [careRequestFromPartner, setCareRequestFromPartner] = useState(
    userInfo && userInfo.profile && userInfo.profile.care_requests_from_partner === true ? "Yes" : "No"
  );

  const [preferredHourlyRate, setPreferredHourlyRateState] = useState(
    userInfo && userInfo.profile && userInfo.profile.preferred_hourly_rate
  );
  const [preferredLocation, setPreferredLocation] = useState(userInfo && userInfo.profile && userInfo.profile.location_of_work);
  const [commutingMeans, setCommutingMeans] = useState(userInfo && userInfo.profile && userInfo.profile.how_commute);
  const [yearsOfExperience, setYearsOfExperience] = useState(userInfo && userInfo.profile && userInfo.profile.years_experience);
  const [nursingLicenseNumber, setNursingLicenseNumber] = useState(userInfo && userInfo.profile && userInfo.profile.nursing_license_number);
  const [applyingAs, setApplyingAs] = useState(userInfo && userInfo.profile && userInfo.profile.applying_as);
  const [training, setTraining] = useState(userInfo && userInfo.profile && userInfo.profile.training);

  const [avatarFilePath, setAvatarFilePath] = useState({ value: "" });
  const [profilePicture, setProfilePicture] = useState(userInfo && userInfo.profile && userInfo.profile.profile_picture);

  const [uploadVaccinationProof, setUploadVaccinationProof] = useState([]);
  const [uploadCertificate, setUploadCertificate] = useState([]);
  const [uploadVoidCheque, setUploadVoidCheque] = useState([]);
  const [workPermitDoc, setWorkPermitDoc] = useState([]);
  const [canadianId, setCanadianId] = useState([]);

  const [youtube, setYoutube] = useState(userInfo && userInfo.profile && userInfo.profile.welcome_video);
  const [facebook, setFacebook] = useState(userInfo && userInfo.profile && userInfo.profile.facebook_profile);
  const [instagram, setInstagram] = useState(userInfo && userInfo.profile && userInfo.profile.instagram_profile);
  const [linkedin, setLinkedin] = useState(userInfo && userInfo.profile && userInfo.profile.linkedin_profile);

  const selectedServiceList = useRecoilValue(selectedServiceListState);
  const [isOpen, setIsOpen] = useState(false);

  const handleDocClick = () => {
    setIsOpen(!isOpen);

    const sDiv = document.getElementById("servicesDiv");
    if (sDiv.style.display === "none") {
      sDiv.style.display = "block";
    } else {
      sDiv.style.display = "none";
    }
    userInfo.profile && userInfo.profile.services && userInfo.profile.services.map((elemId) => {
      const checkbox = document.querySelectorAll(`[class="checkbox-widget"][for="services-${elemId}"]`);

      checkbox[0].setAttribute("data-checked", "true");
      checkbox[0].childNodes[0].setAttribute("data-checked", "true");
    });
  };

  const handleAvatarChange = (e) => {
    const fileInput = document.getElementById(e.target.id);

    const image = document.getElementById(e.target.id).files[0];
    const BgUrl = window.URL.createObjectURL(image);

    document.getElementById("avatar-label").style.backgroundImage = `url(${BgUrl})`;

    setProfilePicture(fileInput.files[0]);
  };
  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };
  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };
  const handleMiddleNameChange = (e) => {
    setMiddleName(e.target.value);
  };
  const handleGender = (e) => {
    setGender(e.target.value);
  };
  const handlePhoneNumber = (e) => {
    setPhoneNumber(e.target.value);
  };
  const handleFaxNumber = (e) => {
    setFaxNumber(e.target.value);
  };
  const handleAdditionalInfo = (e) => {
    setAdditionalInfo(e.target.value);
  };
  const handleAddress = (e) => {
    setAddress(e.target.value);
  };
  const handleCountry = (e) => {
    setCountry(e.target.value);
  };
  const handleCity = (e) => {
    setCity(e.target.value);
  };
  const handleProvince = (e) => {
    setProvince(e.target.value);
  };
  const handlePostalCode = (e) => {
    setPostalCode(e.target.value);
  };

  const handleYoutube = (e) => {
    setYoutube(e.target.value);
  };
  const handleFacebook = (e) => {
    setFacebook(e.target.value);
  };
  const handleInstagram = (e) => {
    setInstagram(e.target.value);
  };
  const handleLinkedin = (e) => {
    setLinkedin(e.target.value);
  };

  // const handleAvailableForWorkWithinOneMonth = (e) => {
  //   setAvailableForWorkWithinOneMonth(e.target.value);
  // };

  // const handleWorkWithDog = (e) => {
  //   setWorkWithDog(e.target.value);
  // };

  // const handleWorkWithCat = (e) => {
  //   setWorkWithCat(e.target.value);
  // };
  // const handleWorkWithSmoker = (e) => {
  //   setWorkWithSmoker(e.target.value);
  // };

  // const handleClimbStairs = (e) => {
  //   setClimbStairs(e.target.value);
  // };

  // const handleCulturalBackground = (e) => {
  //   setCulturalBackground(e.target.value);
  // };

  // const handleAbleToWork = (e) => {
  //   setAbleToWork(e.target.value);
  // };
  const handleCareRequestFromPartner = (e) => {
    setCareRequestFromPartner(e.target.value);
  };

  const handlePreferredLocation = (e) => {
    setPreferredLocation(e.target.value);
  };

  const handleCommutingMeans = (e) => {
    setCommutingMeans(e.target.value);
  };

  // const handlePreferredHourlyRate = (e) => {
  //   setPreferredHourlyRateState(e.target.value);
  // };

  // const handleYearsOfExperience = (e) => {
  //   setYearsOfExperience(e.target.value);
  // };

  // const handleNursingLicenseNumber = (e) => {
  //   setNursingLicenseNumber(e.target.value);
  // };

  // const handleApplyingAs = (e) => {
  //   setApplyingAs(e.target.value);
  // };

  // const handleTraining = (e) => {
  //   setTraining(e.target.value);
  // };

  // const fileUploaderData = (e, theSetter, theState) => {
  //   theSetter(...theState, e.target.files[0]);
  // };

  // const handleUploadProfilePicture = (e) => {
  //   fileUploaderData(e, setUploadProfilePicture, uploadProfilePicture);
  // };
  // const handleUploadVaccinationProof = (e) => {
  //   fileUploaderData(e, setUploadVaccinationProof, uploadVaccinationProof);
  // };

  // const handleUploadCertificate = (e) => {
  //   fileUploaderData(e, setUploadCertificate, uploadCertificate);
  // };

  // const handleUploadVoidCheque = (e) => {
  //   fileUploaderData(e, setUploadVoidCheque, uploadVoidCheque);
  // };
  // const handleWorkPermitDoc = (e) => {
  //   fileUploaderData(e, setWorkPermitDoc, workPermitDoc);
  // };

  // const handleCanadianId = (e) => {
  //   fileUploaderData(e, setCanadianId, canadianId);
  // };

  const editCaregiverProfileData = {
    user: userInfo && userInfo.profile && userInfo.profile.user,

    first_name: firstName,
    last_name: lastName,
    middle_name: middleName,
    gender: gender,
    phone: phoneNumber,
    fax: faxNumber,
    address: address,
    city: city,
    state: province,
    country: country,
    zip: postalCode,
    bio: additionalInfo,

    welcome_video: youtube,
    facebook_profile: facebook,
    instagram_profile: instagram,
    linkedin_profile: linkedin,

    location_of_work: preferredLocation,

    // preferred_hourly_rate: preferredHourlyRate,
    // years_experience: yearsOfExperience,
    // work_with_dog: workWithDog,
    // work_with_cat: workWithCat,
    // work_with_smoker: workWithSmoker,
    // go_up_down_stairs: climbStairs,
    // cultural_background_caregiver: culturalBackground,
    // able_to_work: ableToWork,
    // work_within_1_month: availableForWorkWithinOneMonth,
    care_requests_from_partner: careRequestFromPartner,
    // nursing_license_number: nursingLicenseNumber,
    // applying_as: applyingAs,

    // training: training,

    how_commute: commutingMeans,

    profile_picture: profilePicture,

    services: selectedServiceList,

    // void_cheque: uploadVoidCheque,
    // proof_vaccination: uploadVaccinationProof,
    // canadian_id: canadianId,
    // training_document: uploadCertificate,
    // work_permit: workPermitDoc,
  };

  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [error, setError] = useState(null);
  const [submitData, setSubmitData] = useRecoilState(currentUserInfo);
  const validationErrors = error && Object.values(error);

  const handleEditCustomerProfile = (e) => {
    e.preventDefault();

    const newServicesArray = [];
    const updatedList = document.querySelectorAll('[class="checkbox-widget"][data-checked="true"]');
    Array.prototype.map.call(updatedList, (elem) => {
      newServicesArray.push(elem.childNodes[0].getAttribute("value"));
    });

    if (newServicesArray.length > 0) {
      editCaregiverProfileData.services = newServicesArray;
    } else {
      editCaregiverProfileData.services = userInfo.profile && userInfo.profile.services;
    }

    if (userInfo) {
      setLoading(true);
      let formData = new FormData();

      Object.entries(editCaregiverProfileData).map(([field_name, field_value]) => {
        if (field_value !== null && typeof field_value === "object" && "name" in field_value) {
          formData.append(field_name, field_value, field_value.fileName);
        } else if (field_value !== null && typeof field_value === "object" && field_value.length > 0) {
          field_value.map((value, id) => {
            formData.append(field_name, value);
          });
        } else {
          if (field_name !== "profile_picture") {
            formData.append(field_name, field_value);
          }
        }
      });

      fetch("/api/caregiver/update/", {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${userInfo.accessToken}`,
        },
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.detail === "Successfull updated") {
            let obj = {
              profile: data.caregiver,
              user: data.user,
              accessToken: userInfo.accessToken,
            };
            setSubmitData(obj);
            navigate("/profile");
          }
          if (data.details === "Validations errors") {
            setError(data.errors);
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((error) => {
          setServerError(error);
          setLoading(false);
        });
    }
  };

  return (
    <div>
      <div className="edit-profile-container">
        <h1>{tProfile("Choose the information you want to update:")}</h1>
        <div className={"edit-profile-wrapper"}>
          <div className={"profile-info-section"}>
            <div className={"profile-info-input"}>
              <label htmlFor="first-name">{tProfile("First Name")}</label>
              <input type="text" value={firstName} onChange={handleFirstNameChange} name={"first-name"} id={"first-name"} placeholder={tProfile("Enter your first name here")} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="middle-name">{tProfile("Middle name")}</label>
              <input type="text" value={middleName} onChange={handleMiddleNameChange} name={"middle-name"} id={"middle-name"} placeholder={tProfile("Enter middle name here")} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="last-name">{tProfile("Last Name")}</label>
              <input type="text" value={lastName} onChange={handleLastNameChange} name={"last-name"} id={"last-name"} placeholder={tProfile("Enter your last name here")} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="address-line">{tProfile("Address")}</label>
              <input type="text" value={address} onChange={handleAddress} name={"address-line"} id={"address-line"} placeholder={tProfile("Enter your ADDRESS LINE here")} />
            </div>

            <div className={"profile-info-input"}>
              <label htmlFor="city">{tProfile("City")}</label>
              <input type="text" value={city} onChange={handleCity} name={"city"} id={"city"} placeholder={tProfile("Enter your CITY here")} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="province">{tProfile("State")}</label>
              <div style={{ width: "100%" }}>
                <select name={"province"} id="province" onChange={handleProvince}>
                  <option value="" disabled selected={province === ""}>
                    {tProfile("Select your STATE")}
                  </option>
                  {provincesList.map((val, key) => (
                    <option value={val.id} selected={province === val.id} key={key}>
                      {val[`label_${i18next.language}`]}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="country">{tProfile("Country")}</label>
              <div style={{ width: "100%" }}>
                <select name={"country"} id="country" onChange={handleCountry}>
                  <option value="" disabled selected={country === ""}>
                    {tProfile("Select your COUNTRY")}
                  </option>
                  <option value="CA" selected={country === "CA"}>
                    Canada
                  </option>
                </select>
              </div>
            </div>

            <div className={"profile-info-input"}>
              <label htmlFor="postal-code">{tProfile("Post Code")}</label>
              <input type="text" value={postalCode} onChange={handlePostalCode} name={"postal-code"} id={"postal-code"} placeholder={tProfile("Enter your POSTAL CODE here")} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="phone-number">{tProfile("Phone")}</label>
              <input
                type="text"
                value={phoneNumber}
                onChange={handlePhoneNumber}
                name={"phone-number"}
                id={"phone-number"}
                placeholder={tProfile("Enter your PHONE NUMBER here")}
              />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="fax-number">{tProfile("Fax")}</label>
              <input type="text" value={faxNumber} onChange={handleFaxNumber} name={"fax-number"} id={"fax-number"} placeholder={tProfile("Enter your FAX NUMBER here")} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="gender">{tProfile("Gender")}</label>
              <div style={{ width: "100%" }}>
                <select name={"gender"} id="gender" onChange={handleGender}>
                  <option value="" disabled selected={gender === ""}>
                    {tProfile("Select your caregiver GENDER")}
                  </option>
                  <option value="m" selected={gender === "m"}>
                    {tProfile("Male")}
                  </option>
                  <option value="f" selected={gender === "f"}>
                    {tProfile("Female")}
                  </option>
                  <option value="o" selected={gender === "o"}>
                    {tProfile("Other")}
                  </option>
                </select>
              </div>
            </div>

            {/** START: Social media data **/}
            <div className={"profile-info-input"}>
              <label htmlFor="youtube">{tProfile("Welcome video")}</label>
              <input type="text" value={youtube} onChange={handleYoutube} name={"youtube"} id={"youtube"} placeholder={tProfile("youtube.com/watch?v=[ONLY THIS ID]")} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="facebook">{tProfile("Facebook profile")}</label>
              <input type="text" value={facebook} onChange={handleFacebook} name={"facebook"} id={"facebook"} placeholder={"https://www.facebook.com/..."} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="instagram">{tProfile("Instagram profile")}</label>
              <input type="text" value={instagram} onChange={handleInstagram} name={"instagram"} id={"instagram"} placeholder={"https://www.instagram.com/..."} />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="linkedin">{tProfile("Linkedin profile")}</label>
              <input type="text" value={linkedin} onChange={handleLinkedin} name={"linkedin"} id={"linkedin"} placeholder={"https://www.linkedin.com/..."} />
            </div>
            {/** END: Social media data **/}

            <div className={"profile-info-input"}>
              <label htmlFor="additional-info">{tProfile("Additional info")}</label>
              <textarea
                rows="4"
                id={"additional-info"}
                name={"additional-info"}
                value={additionalInfo}
                onChange={handleAdditionalInfo}
                placeholder={tProfile("Enter additional information here")}
              />
            </div>
          </div>
          <div className={"profile-info-section profile-picture-section"}>
            <div className={"profile-info-input"}>
              <p>{tProfile("Profile picture")}</p>
              <div className={"avatar-label-wrapper"}>
                <label
                  className={"avatar-label"}
                  htmlFor="avatar"
                  id={"avatar-label"}
                  style={{
                    backgroundImage: `url(${userInfo && userInfo.profile && userInfo.profile.profile_picture})`,
                  }}
                >
                  <input
                    style={{ display: "none" }}
                    value={avatarFilePath.value}
                    type="file"
                    id="avatar"
                    name="avatar"
                    accept="image/png, image/jpeg"
                    onChange={handleAvatarChange}
                  />
                </label>
                <label htmlFor="avatar" className={"btn"}>
                  <span>{tProfile("Select Your Photo")}</span>
                  <MdAddAPhoto />
                </label>
              </div>
            </div>

            {/* <div className="file-info-input">
              <label htmlFor="profile-picture">Profile picture</label>
              <BrowseFile
                placeholder="Choose .jpg/.png file"
                buttonTxt="BROWSE"
                id={"profile-picture" + Math.random()}
                value={uploadProfilePicture}
                onChange={handleUploadProfilePicture}
              />
            </div> */}
            {/* <div className="file-info-input">
              <label htmlFor="vaccination-proof">Vaccination proof</label>
              <BrowseFile
                placeholder="Choose .jpg/.png file"
                buttonTxt="BROWSE"
                id={"vaccination-proof" + Math.random()}
                value={uploadVaccinationProof}
                onChange={handleUploadVaccinationProof}
              />
            </div>
            <div className="file-info-input">
              <label htmlFor="pab-psw-nursing-certificate">Training document</label>
              <BrowseFile
                placeholder="Choose .jpg/.png file"
                buttonTxt="BROWSE"
                id={"pab-psw-nursing-certificate" + Math.random()}
                value={uploadCertificate}
                onChange={handleUploadCertificate}
              />
            
            </div>

            <div className="file-info-input">
              <label htmlFor="work-permit">Canadian work permit document</label>
              <BrowseFile
                placeholder="Choose .jpg/.png file"
                buttonTxt="BROWSE"
                id={"work-permit" + Math.random()}
                value={workPermitDoc}
                onChange={handleWorkPermitDoc}
              />
            </div>
            <div className="file-info-input">
              <label htmlFor="void-cheque">Void cheque</label>
              <BrowseFile
                placeholder="Choose .jpg/.png file"
                buttonTxt="BROWSE"
                id={"void-cheque" + Math.random()}
                value={uploadVoidCheque}
                onChange={handleUploadVoidCheque}
              />
            </div>
            <div className="file-info-input">
              <label htmlFor="canadian-id">Canadian ID card</label>
              <BrowseFile
                placeholder="Choose .jpg/.png file"
                buttonTxt="BROWSE"
                id={"canadian-id" + Math.random()}
                value={canadianId}
                onChange={handleCanadianId}
              />
            </div> */}
          </div>

          <div className={"profile-info-section"}>
            {/* <div className={"profile-info-input"}>
              <label htmlFor="additional-info">Preferred hourly rate</label>
              <input
                type="text"
                value={preferredHourlyRate}
                onChange={handlePreferredHourlyRate}
                name={"preferred-hourly-rate"}
                id={"preferred-hourly-rate"}
                placeholder="Enter your HOURLY RATE here"
              />
            </div> */}
            <div className={"profile-info-input"}>
              <label htmlFor="preferred-location">{tProfile("Preferred location of work")}</label>
              <input
                type="text"
                value={preferredLocation}
                onChange={handlePreferredLocation}
                name={"preferred-location"}
                id={"preferred-location"}
                placeholder={tProfile("Enter your PREFERRED LOCATION here")}
              />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="commuting-means">{tProfile("How you will commute")}</label>
              <input
                type="text"
                value={commutingMeans}
                onChange={handleCommutingMeans}
                name={"commuting-means"}
                id={"commuting-means"}
                placeholder={tProfile("Enter your COMMUTING MEANS here")}
              />
            </div>
            <div className={"profile-info-input"}>
              <div className={"input-section-label"}>{tProfile("Want to receive care request from partner?")}</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="careRequestFromPartner-yes">
                  <RadioButton
                    name={"careRequestFromPartner[]"}
                    value={"Yes"}
                    id={"careRequestFromPartner-yes"}
                    checked={careRequestFromPartner === "Yes"}
                    onChange={handleCareRequestFromPartner}
                  />
                  <span>{tProfile("Yes")}</span>
                </label>
                <label htmlFor="careRequestFromPartner-no">
                  <RadioButton
                    name={"careRequestFromPartner[]"}
                    value={"No"}
                    id={"careRequestFromPartner-no"}
                    checked={careRequestFromPartner === "No"}
                    onChange={handleCareRequestFromPartner}
                  />
                  <span>{tProfile("No")}</span>
                </label>
              </div>
            </div>

            {/* <div className={"profile-info-input"}>
              <label htmlFor="applyingAs">Applying as</label>
              <div style={{ width: "100%" }}>
                <select name={"applyingAs"} id="" style={{ width: "100%" }} onChange={handleApplyingAs}>
                  <option value="" disabled selected={applyingAs === ""}>
                    Select what you are APPLYING AS
                  </option>
                  <option value="Companion" selected={applyingAs === "Companion"}>
                    Companion
                  </option>
                  <option value="pab_psw" selected={applyingAs === "pab_psw"}>
                    PAB/PSW
                  </option>
                  <option value="nurse" selected={applyingAs === "nurse"}>
                    Nurse
                  </option>
                  <option value="footcare_specialist" selected={applyingAs === "footcare_specialist"}>
                    Footcare Specialist
                  </option>
                </select>
              </div>
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="nursing-license-number">Nursing license number</label>
              <input
                type="text"
                value={nursingLicenseNumber}
                name={"nursing-license-number"}
                onChange={handleNursingLicenseNumber}
                placeholder="Enter your NURSING LICENSE NUMBER here"
              />
            </div>
            <div className={"profile-info-input"}>
              <label htmlFor="yearsOfExperience">Years of experience</label>
              <div style={{ width: "100%" }}>
                <select name={"yearsOfExperience"} id="" style={{ width: "100%" }} onChange={handleYearsOfExperience}>
                  <option value="" disabled selected={yearsOfExperience === ""}>
                    Select you years of EXPERIENCE
                  </option>
                  <option value="2" selected={yearsOfExperience === "2"}>
                    2 years
                  </option>
                  <option value="5" selected={yearsOfExperience === "5"}>
                    5 years
                  </option>
                  <option value="10" selected={yearsOfExperience === "10"}>
                    10 years
                  </option>
                </select>
              </div>
            </div>

            <div className={"profile-info-input"}>
              <label htmlFor="training">Training</label>
              <div style={{ width: "100%" }}>
                <select name={"training"} id="" value={training} style={{ width: "100%" }} onChange={handleTraining}>
                  <option value="" disabled selected={training === ""}>
                    Select acquired TRAINING
                  </option>
                  <option value="Formal" selected={training === "Formal"}>
                    Formal
                  </option>
                  <option value="CPR" selected={training === "CPR"}>
                    CPR
                  </option>
                  <option value="PDSB" selected={training === "PDSB"}>
                    PDSB
                  </option>
                  <option value="law_90" selected={training === "law 90"}>
                    law 90
                  </option>
                </select>
              </div> 
           </div> */}
          </div>
          {/* <div className={"other-info-section"}>
            <div className={"input-wrapper"}>
              <div className={"input-section-label"}>Are you able to work</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="ableToWork-yes">
                  <RadioButton
                    name={"ableToWork[]"}
                    value={"Yes"}
                    id={"ableToWork-yes"}
                    checked={ableToWork === "Yes"}
                    onChange={handleAbleToWork}
                  />
                  <span>Yes</span>
                </label>
                <label htmlFor="ableToWork-no">
                  <RadioButton
                    name={"ableToWork[]"}
                    value={"No"}
                    id={"ableToWork-no"}
                    checked={ableToWork === "No"}
                    onChange={handleAbleToWork}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div className={"input-wrapper"}>
              <div className={"input-section-label"}>Are you able to work within a month?</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="availableForWorkWithinOneMonth-yes">
                  <RadioButton
                    name={"availableForWorkWithinOneMonth[]"}
                    value={"Yes"}
                    id={"availableForWorkWithinOneMonth-yes"}
                    checked={availableForWorkWithinOneMonth === "Yes"}
                    onChange={handleAvailableForWorkWithinOneMonth}
                  />
                  <span>Yes</span>
                </label>
                <label htmlFor="availableForWorkWithinOneMonth-no">
                  <RadioButton
                    name={"availableForWorkWithinOneMonth[]"}
                    value={"No"}
                    id={"availableForWorkWithinOneMonth-no"}
                    checked={availableForWorkWithinOneMonth === "No"}
                    onChange={handleAvailableForWorkWithinOneMonth}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div className={"input-wrapper"}>
              <div className={"input-section-label"}>Can you work with dog?</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="workWithDog-yes">
                  <RadioButton
                    name={"workWithDog[]"}
                    value={"Yes"}
                    id={"workWithDog-yes"}
                    checked={workWithDog === "Yes"}
                    onChange={handleWorkWithDog}
                  />
                  <span>Yes</span>
                </label>
                <label htmlFor="workWithDog-no">
                  <RadioButton
                    name={"workWithDog[]"}
                    value={"No"}
                    id={"workWithDog-no"}
                    checked={workWithDog === "No"}
                    onChange={handleWorkWithDog}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div className={"input-wrapper"}>
              <div className={"input-section-label"}>Can you work with cat?</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="workWithCat-yes">
                  <RadioButton
                    name={"workWithCat[]"}
                    value={"Yes"}
                    id={"workWithCat-yes"}
                    checked={workWithCat === "Yes"}
                    onChange={handleWorkWithCat}
                  />
                  <span>Yes</span>
                </label>
                <label htmlFor="workWithCat-no">
                  <RadioButton
                    name={"workWithCat[]"}
                    value={"No"}
                    id={"workWithCat-no"}
                    checked={workWithCat === "No"}
                    onChange={handleWorkWithCat}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div className={"input-wrapper"}>
              <div className={"input-section-label"}>Can you work with smoker?</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="workWithSmoker-yes">
                  <RadioButton
                    name={"workWithSmoker[]"}
                    value={"Yes"}
                    id={"workWithSmoker-yes"}
                    checked={workWithSmoker === "Yes"}
                    onChange={handleWorkWithSmoker}
                  />
                  <span>Yes</span>
                </label>
                <label htmlFor="workWithSmoker-no">
                  <RadioButton
                    name={"workWithSmoker[]"}
                    value={"No"}
                    id={"workWithSmoker-no"}
                    checked={workWithSmoker === "No"}
                    onChange={handleWorkWithSmoker}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div className={"input-wrapper"}>
              <div className={"input-section-label"}>Can you climb stairs?</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="climbStairs-yes">
                  <RadioButton
                    name={"climbStairs[]"}
                    value={"Yes"}
                    id={"climbStairs-yes"}
                    checked={climbStairs === "Yes"}
                    onChange={handleClimbStairs}
                  />
                  <span>Yes</span>
                </label>
                <label htmlFor="climbStairs-no">
                  <RadioButton
                    name={"climbStairs[]"}
                    value={"No"}
                    id={"climbStairs-no"}
                    checked={climbStairs === "No"}
                    onChange={handleClimbStairs}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div className={"input-wrapper"}>
              <div className={"input-section-label"}>Cultural background of caregiver?</div>
              <div className={"radio-buttons-wrapper"}>
                <label htmlFor="culturalBackground-yes">
                  <RadioButton
                    name={"culturalBackground[]"}
                    value={"Yes"}
                    id={"culturalBackground-yes"}
                    checked={culturalBackground === "Yes"}
                    onChange={handleCulturalBackground}
                  />
                  <span>Yes</span>
                </label>
                <label htmlFor="culturalBackground-no">
                  <RadioButton
                    name={"culturalBackground[]"}
                    value={"No"}
                    id={"culturalBackground-no"}
                    checked={culturalBackground === "No"}
                    onChange={handleCulturalBackground}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
          </div> */}
          <div className={"profile-info-section"}>
            <div className={"edit-services-wrap"}>
              <span>{tProfile("Select new list of services:")}</span>

              <button className="toggleBtn" onClick={handleDocClick}>
                <span>{isOpen ? <VscCloseAll size={35} /> : <VscExpandAll size={35} />}</span>
              </button>
            </div>
            <div style={{ width: "80%", display: "none" }} id="servicesDiv">
              <ServicesOfferedSelection
              // sectionName={tProfile("Select new list of services:")}
              // error={`${errors.selectedServiceList}`}
              />
            </div>
          </div>
        </div>
        {error ? (
          <div style={{ color: "#ff156a", fontSize: "16px" }}>
            {validationErrors.map((ele, key) => {
              return (
                <div key={key.ele}>
                  <p>{ele}</p>
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
        <div className={"button-wrap"}>
          <div>
            <ButtonLink label={tProfile("BACK")} to={"/profile"} version={"gray"} size={"sm3"} />
          </div>

          {serverError ? <h2 style={{ color: "#ff156a" }}>{tProfile("An unexpected error occurred!")}</h2> : ""}
          {submitData ? <div style={{ color: "#ff156a", float: "right" }}>{submitData.error}</div> : ""}
          <div className={"submit-button"}>
            {loading ? (
              <Spinner loadingMsg={tProfile("Submitting!")} version={"md"} />
            ) : (
              <Button label={tProfile("submit")} size={"sm"} onClick={handleEditCustomerProfile} className={"primary"} version={"green-big"} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditCaregiverProfile;
